import { defineComponent as u, openBlock as t, createElementBlock as o, createVNode as h, createCommentVNode as a, createElementVNode as c, renderSlot as n, toDisplayString as k, createBlock as B } from "vue";
import d from "./index4.js";
const f = { class: "modal-header" }, p = {
  key: 0,
  class: "modal-header-left"
}, _ = { class: "modal-header-center" }, b = {
  key: 0,
  class: "modal-title"
}, C = { class: "modal-header-right" }, x = /* @__PURE__ */ u({
  __name: "ModalHeader",
  props: {
    title: {},
    showBackButton: { type: Boolean, default: !1 },
    showCloseButton: { type: Boolean, default: !0 },
    backButtonText: { default: "뒤로가기" },
    closeButtonText: { default: "모달 닫기" }
  },
  emits: ["back", "close"],
  setup(e, { emit: i }) {
    const s = i, r = () => {
      s("back");
    }, m = () => {
      s("close");
    };
    return (l, w) => (t(), o("header", f, [
      e.showBackButton ? (t(), o("div", p, [
        h(d, {
          class: "modal-back-button",
          icon: { name: "arrow-backward", size: "md" },
          shape: "square",
          padding: "0px",
          size: "md",
          onClick: r
        })
      ])) : a("", !0),
      c("div", _, [
        n(l.$slots, "title", {}, () => [
          e.title ? (t(), o("h2", b, k(e.title), 1)) : a("", !0)
        ])
      ]),
      c("div", C, [
        n(l.$slots, "actions", {}, () => [
          e.showCloseButton ? (t(), B(d, {
            key: 0,
            class: "modal-close-button",
            icon: { name: "close", size: "md" },
            shape: "square",
            padding: "0px",
            size: "md",
            onClick: m
          })) : a("", !0)
        ])
      ])
    ]));
  }
});
export {
  x as default
};
